<div
  [ngStyle]="{ width: width }"
  class="border bg-body bg-opacity-80 rounded-bottom-1 border-top-0 px-2 fs-xs text-body"
>
  {{ distance }}
</div>
